import { Layout } from "antd";
import { Navigate, useParams } from "react-router";

import { useGetAssetType } from "@/entities/asset-type";
import { isError404 } from "@/services/api";

import { AssetTypePageHeader } from "./asset-type-page-header";
import { AssetTypePageTabs } from "./asset-type-page-tabs";

const { Content } = Layout;

const AssetTypePage = () => {
  const { id } = useParams();
  const { isLoading, assetType, error, removeQuery } = useGetAssetType(
    id ?? ""
  );

  if (isError404(error)) {
    removeQuery();
    return <Navigate to="/asset-types" />;
  }

  return (
    <>
      <AssetTypePageHeader assetType={assetType} loading={isLoading} />
      <Content>
        <AssetTypePageTabs assetType={assetType} loading={isLoading} />
      </Content>
    </>
  );
};

export default AssetTypePage;
